import React from 'react';
import {FileController} from "../Boilerplate/FileController";
import {PROJECT} from "../../services";
import ChatWall from "../Boilerplate/ChatWall";
import {Col, Row} from "antd";
import {connect} from "react-redux";

const docKey = ['match', 'params', 'id'];
const subDocKey = null;
const indexType = 'project';
const topLevelName = 'Project';

const _ProjectFiles = FileController(PROJECT, indexType, docKey, subDocKey, topLevelName);

const ProjectFilesContainer = ({projectId}) => <Row gutter={24} align='top'>
  <Col xs={24} lg={17}>
    <_ProjectFiles/>
  </Col>
  <Col xs={24} lg={7}>
    <ChatWall projectId={projectId}/>
  </Col>
</Row>;

export const ProjectFiles = connect(
  (state, props) => ({ projectId: props.match.params.id }),
)(ProjectFilesContainer);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectFiles.js